import styled from '@emotion/styled';

const FAQSectionWrapper = styled.div`
  .header-text {
    margin-bottom: 8px;
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    color: ${(props) => props.theme.colors.primary};
  }
  .content {
    font-size: 16px;
    line-height: 24px;
  }
  .accordion-icon {
    font-size: 48px;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export { FAQSectionWrapper };
